import { render } from "./BaseTooltip.vue?vue&type=template&id=22da02d6&scoped=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"

import "./BaseTooltip.vue?vue&type=style&index=0&id=22da02d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22da02d6"]])

export default __exports__